// utils/phoneUtils.ts
import { getCountries, getCountryCallingCode } from "libphonenumber-js";

export const getCountryCallingCodes = () => {
  return getCountries().map((iso) => ({
    value: `+${getCountryCallingCode(iso)}`,
    label: `${iso} (+${getCountryCallingCode(iso)})`,
  }));
};
